
import {apiurl} from '@/services/config'
import { handleResponse } from '@/services/handleresponse'


export const BayarTempoService = {
    getBills,
    updateBills,
    fetchRekening,
    addRekening,
    fectVirtualAccount,
    doCashout,
    getBalance
}

function getBills (opt) {
    console.log(opt)

    if(opt.itemsPerPage<0){
        opt.itemsPerPage=10000
    }
    let page=opt.page-1;
    // let sorting=sort+","+sorder
    return fetch(apiurl + '/backoffice/bayartempo/serpulbills?identity=111&awal='+opt.awal+"&akhir="+opt.akhir+'&page='+page+'&size='+opt.itemsPerPage+"&sort=id,desc", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function fetchRekening (opt) {
    console.log(opt)

    if(opt.itemsPerPage<0){
        opt.itemsPerPage=10000
    }
    // let sorting=sort+","+sorder
    //TODO: CHANGE TO PRODUCTION
    return fetch(apiurl + '/backoffice/bayartempo/serpul-rekening', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function updateBills (opt) {
    console.log(opt)

    return fetch(apiurl + '/backoffice/bayartempo/serpulbills/payment/'+opt.id, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function addRekening (opt) {
    console.log(opt)

    return fetch(apiurl + '/backoffice/bayartempo/serpul-rekening/add', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify({
            bankNo: opt.norek,
            name: opt.name
        })
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function doCashout (opt) {
    console.log(opt)

    return fetch(apiurl + '/backoffice/bayartempo/serpul-rekening/cashout', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify({
            identity: "1111",
            id: opt.id,
            amount: opt.amount
        })
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function getBalance (opt) {
    console.log(opt)

    return fetch(apiurl + '/backoffice/bayartempo/serpul-rekening/balance', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        },
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function fectVirtualAccount (opt) {
    console.log(opt)
    // let sorting=sort+","+sorder
    return fetch(apiurl + '/backoffice/bayartempo/billva?identity=111&billid='+opt, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}
